import { Select as AntSelect } from 'antd';
import styled from 'styled-components';

export const Select = styled(AntSelect)`
  width: 100%;
  && {
    .ant-select-selection-search-input,
    .ant-select-selection-placeholder {
      padding-left: var(--spacing-05);
    }
  }
`;

export const TaskNameContainer = styled.div`
  padding-left: var(--spacing-05);
`;
